var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("通知模板管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: { content: _vm.title },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.ruleForm1.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name", $$v)
                            },
                            expression: "ruleForm1.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转地址", prop: "url" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.ruleForm1.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "url", $$v)
                            },
                            expression: "ruleForm1.url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "事件类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择类型" },
                            model: {
                              value: _vm.ruleForm1.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type", $$v)
                              },
                              expression: "ruleForm1.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "系统通知", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "任务通知", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "通道类型", prop: "type1" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.ruleForm1.type1,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type1", $$v)
                              },
                              expression: "ruleForm1.type1",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "1" } }, [
                              _vm._v("极光推送"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "2" } }, [
                              _vm._v("短信"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发送对象", prop: "type2" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.ruleForm1.type2,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type2", $$v)
                              },
                              expression: "ruleForm1.type2",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "1" } }, [
                              _vm._v("用户"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "2" } }, [
                              _vm._v("临勤"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "3" } }, [
                              _vm._v("员工"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "4" } }, [
                              _vm._v("保安公司"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "触发次数", prop: "num" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择类型" },
                            model: {
                              value: _vm.ruleForm1.num,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "num", $$v)
                              },
                              expression: "ruleForm1.num",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "多次触发", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "单词触发", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm1.num == "0"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "触发规则", prop: "list" } },
                          [
                            _c(
                              "div",
                              _vm._l(
                                _vm.ruleForm1.list,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "margin-bottom": "15px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            "margin-right": "auto",
                                          },
                                          attrs: { placeholder: "请选择类型" },
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectType("ruleForm")
                                            },
                                          },
                                          model: {
                                            value: item.type,
                                            callback: function ($$v) {
                                              _vm.$set(item, "type", $$v)
                                            },
                                            expression: "item.type",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "到点触发",
                                              value: "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: "提前触发",
                                              value: "1",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: "延迟触发",
                                              value: "2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      item.type != "0"
                                        ? _c(
                                            "el-input",
                                            {
                                              staticStyle: {
                                                "margin-left": "20px",
                                              },
                                              attrs: {
                                                placeholder: "请输入分钟数",
                                              },
                                              on: { blur: _vm.selectType },
                                              model: {
                                                value: item.time,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "time", $$v)
                                                },
                                                expression: "item.time",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("分钟")]
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("i", {
                                            staticClass:
                                              "el-icon-circle-plus-outline",
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                            on: { click: _vm.addSelect },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index != 0
                                        ? _c("i", {
                                            staticClass:
                                              "el-icon-remove-outline",
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteSelect(index)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知内容", prop: "memo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入通知内容",
                          },
                          model: {
                            value: _vm.ruleForm1.memo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo", $$v)
                            },
                            expression: "ruleForm1.memo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "50px" },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm1("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }